import React from 'react';
import ReactGA from 'react-ga';
import GIECard from '../../components/GIECard/GieCard';
import GIETextField from '../../components/GIETextField/GieTextField';
import GIEButton from '../../components/GIEButton/GieButton';
import {FormValidator} from '../../util/form-validator';
import LoginController from '../../controller/login.controller';
import GIELink from "../../components/GIELink/GIELink";
import MailIcon from '@material-ui/icons/Mail';

export default class ChangePassword extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();
  loginController: LoginController = new LoginController();

  constructor(props) {
    super(props);
    this.state = {
      formControls: {
        createPassword: {
          value: '',
          error: false,
          errorMessage: ''
        },
        confirmPassword: {
          value: '',
          error: false,
          errorMessage: ''
        }
      },
      passwordChanged: false
    }
  }

  componentDidMount() {
    const token = window.location.href.split('/')[window.location.href.split('/').length - 1]
    const noContract = window.location.href.split('/')[window.location.href.split('/').length - 2]
    this.setState({noContract, token})
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const error = this.formValidator.returnError(value, name);
    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: {
          ...this.state.formControls[name],
          value,
          error: error.error,
          errorMessage: error.errorMessage
        }
      }
    });
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    let isError = false;

    Object.keys(formControls).forEach(name => {
      const error = this.formValidator.returnError(formControls[name].value, name)
      formControls[name].error = error.error;
      formControls[name].errorMessage = error.errorMessage;
      if (error.error === true) {
        isError = true
      }
    });

    if (formControls["createPassword"].value !== formControls["confirmPassword"].value) {
      formControls["confirmPassword"].error = true;
      formControls["confirmPassword"].errorMessage = "Les mots de passes ne sont pas identiques";
    }
    this.setState(formControls)
    return isError;
  }

  authenticate = () => {
    if (this.checkValidForm() === false) {
      const request = {
        noContract: this.state.noContract,
        token: this.state.token,
        password: this.state.formControls.confirmPassword.value
      }
      this.loginController.changePassword(request).then(data => {
        this.setState({passwordChanged: true})
      }).catch(err => {
        console.log(err)
      })
    }
  }

  render() {
    return (
      <div className="content">
        <div className="blue-bg-container">
          <div className="m-auto">
            <GIECard width="500px" height="100%">
              <div className="p-4">
                {this.state.passwordChanged === false ? (
                  <div>
                    <h2 className="text-center">Mot de passe oublié</h2>
                    <div className="my-5">
                      <GIETextField label="Votre nouveau mot de passe"
                                    required
                                    type="password"
                                    onChange={this.changeHandler}
                                    name="createPassword"
                                    value={this.state.formControls.createPassword.value}
                                    helperText={this.state.formControls.createPassword.errorMessage}
                                    error={this.state.formControls.createPassword.error}/>
                      <GIETextField label="Confirmer votre mot de passe"
                                    required
                                    type="password"
                                    onChange={this.changeHandler}
                                    name="confirmPassword"
                                    value={this.state.formControls.confirmPassword.value}
                                    helperText={this.state.formControls.confirmPassword.errorMessage}
                                    error={this.state.formControls.confirmPassword.error}/>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <GIELink href="/admin/login" arrowBefore>Se connecter</GIELink>
                      <GIEButton onClick={this.authenticate} classes={{root: 'orange-btn'}}>Valider</GIEButton>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="text-center">
                      <MailIcon className="big"/>
                    </div>
                    <div className="text-center my-5">
                      <span>Vous avez modifié votre mot de passe</span>
                    </div>
                    <div className="text-center">
                      <GIELink href="/admin/login" arrowAfter>Se connecter</GIELink>
                    </div>
                  </div>
                )}
              </div>
            </GIECard>
          </div>
        </div>
      </div>
    );
  }
}
